import { Injectable } from "@angular/core";
import { ObgConfigFeAdaptiveClientGaming } from "@obg/gaming.config";
import { ConfigService } from "@obg/ngx.global";

@Injectable({
	providedIn: "root",
})
export class SkillGamesConfigService {
	constructor(private config: ConfigService<ObgConfigFeAdaptiveClientGaming>) {}

	getIsSkillGamesRouteEnabled(): boolean {
		return this.config.get((x) => x.gaming.skillGamesLobby.isEnabled, false);
	}
}
